import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { assetManagementClassNameConfig } from './AssetManagementClass.name';

enum AssetManagementClass {
  normalAsset = 'NORMAL_ASSET',
  smallSumAsset = 'SMALL_SUM_ASSET',
  lumpSumDepreciableAsset = 'LUMP_SUM_DEPRECIABLE_ASSET',
  unaccountedAsset = 'UNACCOUNTED_ASSET',
  researchAndDevelopmentExpense = 'RESEARCH_AND_DEVELOPMENT_EXPENSE',
  ownershipRightsTransferLease = 'OWNERSHIP_RIGHTS_TRANSFER_LEASE',
  ownershipRightsNonTransferLease = 'OWNERSHIP_RIGHTS_NON_TRANSFER_LEASE',
}

const assetManagementClassMap = new Map([
  ['NORMAL_ASSET', AssetManagementClass.normalAsset],
  ['SMALL_SUM_ASSET', AssetManagementClass.smallSumAsset],
  ['LUMP_SUM_DEPRECIABLE_ASSET', AssetManagementClass.lumpSumDepreciableAsset],
  ['UNACCOUNTED_ASSET', AssetManagementClass.unaccountedAsset],
  ['RESEARCH_AND_DEVELOPMENT_EXPENSE', AssetManagementClass.researchAndDevelopmentExpense],
  ['OWNERSHIP_RIGHTS_TRANSFER_LEASE', AssetManagementClass.ownershipRightsTransferLease],
  ['OWNERSHIP_RIGHTS_NON_TRANSFER_LEASE', AssetManagementClass.ownershipRightsNonTransferLease],
]);

const rawValueToAssetManagementClass = rawValueToEnumWithDefault(
  assetManagementClassMap,
  AssetManagementClass.normalAsset,
);

const assetManagementClassToDisplay = enumToNameWithDefault(
  AssetManagementClass,
  assetManagementClassNameConfig,
);

const assetManagementClassToDisplayWithPrefix = enumToNameWithDefault(
  AssetManagementClass,
  assetManagementClassNameConfig,
  true,
);

export {
  AssetManagementClass,
  assetManagementClassToDisplay,
  assetManagementClassToDisplayWithPrefix,
  rawValueToAssetManagementClass,
};
